import {useMemo} from 'react'

import {LanguagesEnum} from '../locale/types'
import {useLocale} from '../utils/i18n'
import {DAY_LABEL_KEYS, FormatOpeningTimesOptions} from './pass-hours'

/** Day names come from the app's own translations; Hebrew keeps its times left-to-right. */
export const usePassHoursOptions = (): FormatOpeningTimesOptions => {
  const {l, language} = useLocale()
  return useMemo(
    () => ({
      dayLabels: {
        monday: l(DAY_LABEL_KEYS.monday),
        tuesday: l(DAY_LABEL_KEYS.tuesday),
        wednesday: l(DAY_LABEL_KEYS.wednesday),
        thursday: l(DAY_LABEL_KEYS.thursday),
        friday: l(DAY_LABEL_KEYS.friday),
        saturday: l(DAY_LABEL_KEYS.saturday),
        sunday: l(DAY_LABEL_KEYS.sunday),
      },
      allDayLabel: l('pass_all_day'),
      isolateTimes: language === LanguagesEnum.HEB,
    }),
    [l, language],
  )
}
